import React from 'react';
import { CheckCircle2, HelpCircle } from 'lucide-react';
export function HelpModuleAndFAQ() {
  return <div className="bg-brand-cream border-t border-brand-border py-16" data-id="element-42">
      <div className="max-w-7xl mx-auto px-4" data-id="element-43">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-44">
          {/* Help Module */}
          <div className="lg:col-span-5" data-id="element-45">
            <div className="bg-white rounded-xl p-8 border border-brand-border shadow-sm" data-id="element-46">
              <div className="w-12 h-12 bg-brand-green/10 text-brand-green rounded-full flex items-center justify-center mb-6" data-id="element-47">
                <HelpCircle size={24} data-id="element-48" />
              </div>
              <h3 className="text-2xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-49">
                Need help with a commercial mailbox project?
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-50">
                Before you order, let our experts review your requirements to
                ensure a perfect fit.
              </p>

              <ul className="space-y-3 mb-8" data-id="element-51">
                {['Door count', 'Parcel locker ratio', 'Numbering sequence', 'USPS/project requirements', 'Replacement vs new install', 'Installation/service area'].map(item => <li key={item} className="flex items-center gap-3 text-sm font-medium text-brand-charcoal" data-id="element-52">
                    <CheckCircle2 size={18} className="text-brand-gold" data-id="element-53" />{' '}
                    {item}
                  </li>)}
              </ul>

              <a href="/ContactUs.html" className="block w-full bg-brand-green hover:bg-brand-green/90 text-white text-center py-3.5 rounded-md font-bold transition-colors shadow-sm" data-id="element-54">
                Request a pre-order review
              </a>
            </div>
          </div>

          {/* FAQs */}
          <div className="lg:col-span-7 lg:pl-8" data-id="element-55">
            <h3 className="text-2xl font-serif font-bold text-brand-charcoal mb-8" data-id="element-56">
              Frequently Asked Questions
            </h3>

            <div className="space-y-6" data-id="element-57">
              <div data-id="element-58">
                <h4 className="font-bold text-lg text-brand-charcoal mb-2" data-id="element-59">
                  Do I need USPS approval?
                </h4>
                <p className="text-gray-600 leading-relaxed" data-id="element-60">
                  Most new commercial installations require local Postmaster
                  approval before installation. We recommend checking with your
                  local USPS office regarding location and equipment
                  requirements.
                </p>
              </div>

              <div data-id="element-61">
                <h4 className="font-bold text-lg text-brand-charcoal mb-2" data-id="element-62">
                  How do I choose the right door count?
                </h4>
                <p className="text-gray-600 leading-relaxed" data-id="element-63">
                  Count your total number of tenants/units. USPS requires at
                  least one parcel locker for every 5 tenant compartments (1:5
                  ratio) for new installations.
                </p>
              </div>

              <div data-id="element-64">
                <h4 className="font-bold text-lg text-brand-charcoal mb-2" data-id="element-65">
                  Can MidAtlantic help with numbering?
                </h4>
                <p className="text-gray-600 leading-relaxed" data-id="element-66">
                  Yes. We can help you plan standard sequential numbering or
                  custom engraved numbering sequences to match your property
                  layout.
                </p>
              </div>

              <div data-id="element-67">
                <h4 className="font-bold text-lg text-brand-charcoal mb-2" data-id="element-68">
                  Can I replace only locks, doors, or hinges?
                </h4>
                <p className="text-gray-600 leading-relaxed" data-id="element-69">
                  Yes, we carry a full line of replacement parts for major
                  commercial mailbox brands. You don't always need to replace
                  the entire unit.
                </p>
              </div>

              <div data-id="element-70">
                <h4 className="font-bold text-lg text-brand-charcoal mb-2" data-id="element-71">
                  Can I get installation?
                </h4>
                <p className="text-gray-600 leading-relaxed" data-id="element-72">
                  We offer professional installation services in select areas of
                  MD, VA, DC, PA, and WV. Contact us for a quote.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}